import logo from './logo.svg';
import './App.css';
import { db } from './FirebaseConfig';
import { Form, InputGroup, ToggleButton } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useRef, useEffect } from 'react';
import { set, ref, get } from 'firebase/database';
import 'firebase/database';
import firebase from "firebase/compat/app"; // Import the firebase library
import { QRCodeCanvas } from 'qrcode.react';


function App() {


  const [checked, setChecked] = useState(false);
  const [SUrl, setSUrl] = useState();
  const targetUrl = useRef();
  const qrcode = require('qrcode.react');

  // const generateQRCode = (data) => {
  //   const qrcodeImage = qrcode.create(data, {
  //     width: 200,
  //     height: 200,
  //   });
  
  //   const canvas = document.createElement('canvas');
  //   canvas.width = qrcodeImage.width;
  //   canvas.height = qrcodeImage.height;
  
  //   const ctx = canvas.getContext('2d');
  //   ctx.drawImage(qrcodeImage, 0, 0);
  
  //   return canvas;
  // };
  const shortUrl = (e) => {
    e.preventDefault();
    // alert('on work')


    if(targetUrl.current.value.startsWith("http")){





    const randomCode = makeid(6);


    const databaseRef = ref(db, randomCode);

    // Fetch data once from the database
    get(databaseRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());

          const NrandomCode = makeid(6);
          set(ref(db, NrandomCode), {
            redirect_url: targetUrl.current.value
          })
            .then(() => {
              // Data saved successfully!
              alert("Done!")
            })
            .catch((error) => {
              // The write failed...
              alert(error)
            });
        } else {
          console.log(null); // Node doesn't exist
          set(ref(db, randomCode), {
            redirect_url: targetUrl.current.value
          })
            .then(() => {
              // Data saved successfully!

              alert("Done! Click Ok To See Shortened Url")
              setSUrl(window.location.href + randomCode)
              const surld = document.getElementById("surld");
              const newLink = document.createElement("a");
              const br = document.createElement("br");
              const newLinkQR = document.createElement("img");
              newLinkQR.src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data="+window.location.href+randomCode;
              newLink.value = window.location.href+randomCode;
              newLink.target = "_blank";
              newLink.href = window.location.href + randomCode;
              newLink.innerText = window.location.href + randomCode;
              surld.appendChild(newLink);
// https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=Example
              surld.appendChild(br);
              surld.appendChild(br);
              surld.appendChild(newLinkQR);
              surld.appendChild(br);
              surld.appendChild(br);
              surld.appendChild(br);
              surld.appendChild(br);

            })
            .catch((error) => {
              // The write failed...
              alert(error)
            });
        }
      })
      .catch((error) => {
        alert("Error fetching data:", error);

      });
}
else{
  alert("Only Website Links (Urls) can be shortened!");
}

  }
  function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  useEffect(() => {

    
    const shortedSecret = window.location.pathname;

    const databaseRef = ref(db, shortedSecret);

    // Fetch data once from the database
    get(databaseRef)
      .then((snapshot) => {
        if (snapshot.exists()) {
          // After obtaining snapshot.val()
          const data = snapshot.val();
          const parameter1Value = data?.redirect_url ?? "";
          console.log(parameter1Value); // This will log the value of "parameter1" or "default value" if it doesn't exist
          if(parameter1Value.startsWith("http")){
            window.location.replace(parameter1Value);
          }
        } else {

        }
      })
      .catch((error) => {
        alert("Error fetching data:", error);

      });

  }, []);
  return (
    <>
      <center>
        <h1>Url Shortener By PSS</h1><br /><br />
        <h6>You can use this as tool for free. You have no need to login. It is completely free and secure.</h6><br /><br />
        <h6>You can long press or right click on QR code to download, and share it.</h6><br /><br />
        <div className="form">
          <Form onSubmit={shortUrl}>

            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                Enter Your URL Here:
              </InputGroup.Text>
              <Form.Control
                aria-label="Default"
                ref={targetUrl}
                aria-describedby="inputGroup-sizing-default"
                required
              />
            </InputGroup>

            <ToggleButton
              className="mb-2"
              id="toggle-check"
              type="submit"
              typeof='checkbox'
              variant="outline-primary"
              checked={checked}
              value="1"
              onChange={(e) => setChecked(e.currentTarget.checked)}
            >
              Shorten The URL
            </ToggleButton>
            

          </Form>
          <br /><br />
          <div id='surld'>Shortened Url's: <br />{/* <a href={SUrl}>{SUrl}</a><br /> */}</div>

        </div>




      </center>
    </>
  );
}

export default App;
